export const cardMediaStyles = {
  height: { xs: 52, sm: 140 },
  objectFit: 'cover'
};
